module.exports = require("./be.d.ts");